// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLumeraError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" class="svg-fg"/>
  <path d="M9.10305 1H0V9H4.21252C4.39573 8.29586 4.61137 7.62963 4.85599 7H2L2 3H7.13491C7.59471 2.42575 8.08685 1.90408 8.60453 1.43241 8.76916 1.28242 8.93544 1.13834 9.10305 1ZM5 18.9511V24H7V20L11 17.2353V13L0 16V24H2V17.5276L9 15.6185V16.1864L5 18.9511Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M19 0H17V4H15V8.8309L12 9.63121L12.5176 11.5631L15 10.9014V12H21V10.901L23.4472 11.5602L24 9.62839L21 8.83043V4H19V0ZM19 6H17V10H19V6Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.95151 2.9108C12.4092 0.671588 15.2846 0 17 0V2C15.7154 2 13.3408 2.52841 11.2985 4.3892C9.28965 6.21947 7.5 9.43311 7.5 15H5.5C5.5 8.96689 7.46035 5.18053 9.95151 2.9108Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLumeraError is a generated icon component.
 */
let IconMedLumeraError = IconMedLumeraError_1 = class IconMedLumeraError extends IconBaseElement {
    render() {
        return html `${IconMedLumeraError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLumeraError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedLumeraError = IconMedLumeraError_1 = __decorate([
    customElement('zui-icon-med-lumera-error')
], IconMedLumeraError);
export { IconMedLumeraError };
